// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__15M6U","overflowing":"ReadFullNote_overflowing__29Mxe"};